import { Box, Text, Tooltip } from '@chakra-ui/react';

import { CodeBlock } from '@atlaskit/code';
import React from 'react';
import { CopyIcon } from '@chakra-ui/icons';

export const CodeSnippet = ({ data, header }: { data: string; header: string }) => {
	const copy = () => {
		navigator.clipboard.writeText(data);
	};

	return (
		<Box
			padding="0px"
			pos="relative"
			mb="40px"
			mt="20px"
			maxW={{ base: '100vw', hashup: '100%' }}
			overflowX="hidden"
		>
			<Text
				textTransform="uppercase"
				fontWeight="600"
				fontSize="10px"
				lineHeight="10px"
				letterSpacing=".4em"
				cursor="pointer"
				mb="20px"
			>
				{header}
			</Text>
			<Box
				overflowY="scroll"
				maxH="400px"
				pos="relative"
			>
				<Tooltip label="Copy to clipboard">
					<CopyIcon
						onClick={copy}
						bg="#f5f5f7"
						padding="5px"
						top="10px"
						boxSize="30px"
						cursor="pointer"
						right="10px"
						color="black"
						pos="absolute"
					/>
				</Tooltip>

				<CodeBlock
					text={data}
					language={'javascript'}
					showLineNumbers={true}
				/>
			</Box>
		</Box>
	);
};
